import { createStore, action} from 'easy-peasy';

export const store = createStore({
  activeSongs: [],
  activeSong: null,
  changeActiveSongs: action((state, payload) => {
    state.activeSongs = payload
  }),
  changeActiveSong: action((state, payload) => {
    state.activeSong = payload
  }),
})